import { GeoJSON } from 'react-leaflet';
import { clearWindowURLParams } from 'utils/utils';
import { AssetTotalCount } from '../components/ToolTips/AssetTotalCount';
import BuildingLabelTooltip from '../components/ToolTips/BuildingLabelTooltip';
import UsersTotalCount from '../components/ToolTips/UsersTotalCount';
import useMap from '../hooks/useMap';
import { useMapStore } from 'contexts/RootStore.context';
import { observer } from 'mobx-react';
import DevicesTotalCount from '../components/ToolTips/DevicesTotalCount';

// this layer will render the initial buildings outline GEOJSON.
// once a building is clicked, we render the unitGeoJsonLayer over the top of this, that will be dependant on floor selected.
export const BuildingsGeoJsonLayer = observer(() => {
  const {
    buildings,
    getBuildingLevels,
    selectBuilding,
    selectedBuildingId,
    showAssetMarkers,
    showUserMarkers,
    showDeviceMarkers,
  } = useMapStore()
  const { fitMapToBoundsOfGeoJSON } = useMap(useMapStore());

  function handleBuildingGeoJsonClick(buildingID: string) {
    // clicking on a building will pass the buildingID, which we then use to render the unit GeoJSON.
    const newBuildingSelected = buildingID !== selectedBuildingId;

    if (newBuildingSelected) {
      selectBuilding(buildingID)
      fitMapToBoundsOfGeoJSON(getBuildingLevels(buildingID)); // center map to feature bounds.
    }
    clearWindowURLParams();
  }

  // note we are using buildingFeatures to map over iterations, but levelFeatures to render the actual geojson.
  // this is because buildingFeatures.json does not have geometry data, but contains a building ID that can be referenced in levels to obtain level geometry.
  // we then loop over each building, then render geoJson with all combined level data for that building.
  // this will render the levels outline of each building
  return buildings.features.map(buildingFeature => {
    const buildingLevels = getBuildingLevels(buildingFeature.id);
    const buildingIsSelected = selectedBuildingId === buildingFeature.id;

    return (
      <div key={buildingFeature.id}>
        <BuildingLabelTooltip buildingName={buildingFeature.properties.name.en} buildingFeature={buildingFeature} />

        {showAssetMarkers && (
          <AssetTotalCount buildingFeature={buildingFeature} />
        )}
        {showUserMarkers && (
          <UsersTotalCount buildingFeature={buildingFeature} />
        )}
        {showDeviceMarkers && (
          <DevicesTotalCount buildingFeature={buildingFeature} />
        )}

        <GeoJSON
          eventHandlers={{
            click: () => {
              handleBuildingGeoJsonClick(buildingFeature.id);
            },
          }}
          style={{
            fillColor: '#E6F0FC',
            fillOpacity: buildingIsSelected ? 0 : 1, // note we set opacity to 0 of building selected, as units covers this.
            color: '#719ED3',
          }}
          data={buildingLevels as any}
        />
      </div>
    );
  });
})
